import {Injectable} from '@angular/core';
import {EtsQtyToMarketSidePipe} from "./market-side.pipe";

@Injectable()
export class HgTestingService {

    constructor() {
    }

    public run() {
        console.group('Testing HgTestingService');

        this.testEtsQtyToMarketSidePipe();

        console.groupEnd();
    }

    public testEtsQtyToMarketSidePipe() {

        console.log('Testing EtsQtyToMarketSidePipe');

        const pipe = new EtsQtyToMarketSidePipe();

        const mustBeShort = pipe.transform(-1);
        console.assert(mustBeShort === 'Short', 'Expected -1 to return Short');

        const mustBeFlat = pipe.transform('0');
        console.assert(mustBeFlat === 'Flat', 'Expected 0 to return Flat');

        const mustBeLong = pipe.transform(1);
        console.assert(mustBeLong === 'Long', 'Expected 1 to return Long');

        const mustBeNA = pipe.transform("");
        console.assert(mustBeNA === 'N/A', 'Expected "" to return N/A');

        const mustBeLong1 = pipe.transform("1");
        console.assert(mustBeLong1 === 'Long', 'Expected "1" to return Long');

        const mustBeShort1 = pipe.transform("-1");
        console.assert(mustBeShort1 === 'Short', 'Expected "-1" to return Short');

        console.log('End of Testing EtsQtyToMarketSidePipe');
    }
}